var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-tag',{attrs:{"on-black":""}},[_vm._v(" "+_vm._s(_vm.envName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }